<div class="lv-container">
    <img width={{width}} src="../../../../../assets/images/logo-white.svg" />
    <span class="lv-title" [ngClass]="{'macos-font': currentOS === OS.Mac, 'windows-font': currentOS === OS.Windows}">
        {{title}}
    </span>
</div>